import { ChallengeInfoForAdmin, ReqCreateOrUpdateChallenge } from '@types';
import {
  ChallengeFormType,
  ConverterData2Form,
  ConverterForm2Data,
} from '../../NewChallengeForm.types';

export const convertData2Form: ConverterData2Form<
  Pick<ChallengeInfoForAdmin, 'tags'>,
  Pick<ChallengeFormType, 'tagIds'>
> = ({ tags }) => ({ tagIds: tags?.map(({ id }) => id) || [] });

export const convertForm2Data: ConverterForm2Data<
  Pick<ChallengeFormType, 'tagIds'>,
  Pick<ReqCreateOrUpdateChallenge, 'tagIds'>
> = ({ tagIds }) => ({ tagIds });
